import { Dialog } from "@minuthq/meatball-ui-react"

import { DeviceConfigurationView } from "src/components/Homes/DeviceDetails/Configuration/DeviceConfigurationView"
import { useFetchDevices } from "src/data/devices/queries/deviceQueries"
import { TDevice } from "src/data/devices/types/deviceTypes"
import { useOrganization } from "src/data/organizations/hooks/useOrganization"
import { langKeys } from "src/i18n/langKeys"
import { useTranslate } from "src/i18n/useTranslate"

export function DeviceSettingsDialog({
  open,
  onClose,
  devices,
}: {
  open: boolean
  onClose: () => void
  devices: TDevice[]
}) {
  const { t } = useTranslate()

  const { orgId } = useOrganization()
  const ids = devices.map((d) => d.device_id)
  const fetchDevices = useFetchDevices({
    orgId: orgId,
    filter: { ids, limit: ids.length },
    options: {
      enabled: ids.length > 0,
    },
  })
  const fetchedDevices = fetchDevices.data?.devices || []

  return (
    <Dialog
      width="full"
      open={open}
      onClose={onClose}
      aria-labelledby="configure-devices-dialog-title"
      aria-describedby="configure-devices-dialog-description"
      closeLabel={t(langKeys.close)}
    >
      <DeviceConfigurationView title="Settings" devices={fetchedDevices} />
    </Dialog>
  )
}
